import { Box, Breadcrumbs as MuiBreadcrumbs } from '@mui/material'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import type { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import type { BreadcrumbsProps } from './types'
import { styles } from './styles'

export const Breadcrumbs: FC<BreadcrumbsProps> = (props) => {
  const { items } = props
  const navigate = useNavigate()

  const renderItems = items.map((item) =>
    item.href ? (
      <Link
        sx={styles.item}
        key={item.href}
        underline="hover"
        color="inherit"
        href={item.href}
        onClick={(e) => {
          e.preventDefault()
          navigate(item.href as string)
        }}
      >
        {item.title}
      </Link>
    ) : (
      <Typography sx={styles.item} key={item.title} color="text.primary">
        {item.title}
      </Typography>
    )
  )

  return (
    <Box mb={2}>
      <MuiBreadcrumbs aria-label="breadcrumb">{renderItems}</MuiBreadcrumbs>
    </Box>
  )
}
